import { CompactSelection } from '@glideapps/glide-data-grid';
import type { GridSelection } from '@glideapps/glide-data-grid';

interface FinancialRowFocusTarget {
    lineItemAliases?: readonly string[];
    lineItemKey?: string;
}

export const createFocusedFinancialRowSelection = (row: number): GridSelection => ({
    columns: CompactSelection.empty(),
    rows: CompactSelection.empty().add(row),
});

export const matchesFinancialRowFocus = (target: FinancialRowFocusTarget, focusLineItem: string) =>
    target.lineItemKey === focusLineItem || target.lineItemAliases?.includes(focusLineItem) === true;
